import { render } from "./scroll-arrows.vue?vue&type=template&id=a5ea0840&scoped=true&ts=true"
import script from "./scroll-arrows.vue?vue&type=script&lang=ts"
export * from "./scroll-arrows.vue?vue&type=script&lang=ts"

import "./scroll-arrows.vue?vue&type=style&index=0&id=a5ea0840&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ea0840"]])

export default __exports__